import Drawer, { type DrawerProps } from '@liquidweb-dev/undercurrent/Drawer';
import DrawerHeader from '@liquidweb-dev/undercurrent/DrawerHeader';

export interface WrapperProps extends Omit<DrawerProps, 'onClose'> {
	onClose: () => void;
}

const Wrapper = ({ onClose, children, ...drawerProps }: WrapperProps) => {
	return (
		<Drawer anchor="right" onClose={onClose} {...drawerProps}>
			<DrawerHeader onClose={onClose}>Checkout</DrawerHeader>
			{children}
		</Drawer>
	);
};

export default Wrapper;
